import { render, staticRenderFns } from "./HealthRequest.vue?vue&type=template&id=5090449a&scoped=true&"
import script from "./HealthRequest.vue?vue&type=script&lang=js&"
export * from "./HealthRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5090449a",
  null
  
)

export default component.exports